import React from 'react'
import {PlusOutlined} from '@ant-design/icons'
import {Form, Input, Message, Select, Switch, Upload} from 'antd'
import {addOrEditCommodity, fetchQiniu, fetchQiNiuToken, getCommodityDetail,} from '../../../api/businessCommodity'
import {fixPhotoUrl, validateImageFile} from '../../../util/index'
import '../Merchandise/style.css'

export default class extends React.Component {
  state = {
    barCode: '',
    QiniuToken: '',
    allData: {},
    fileList: [],
    photoUrl: '',
    name: '',
    unit: '',
    order: '',
    categoryId: '',
    isNonStandard: false,
  }

  componentDidMount() {
    if (this.props.modalState == 'isAddCommodity') {
      this.getQiniuToken()
    }
    if (this.props.modalState == 'isDetails') {
      this.getQiniuToken()
      this.getCommodityDetailData()
    }
  }

  getBarCode = async (listingId, clubId, barCode) => {
    if (this.props.modalState == 'isAddCommodity') {
      const { data, detail, status } = await getCommodityDetail(
          '',
          '',
          this.state.barCode
      )
      if (status == 1) {
        const url = data.commodity.photoUrl
        if (url!=="https://images.sport147.cn"&&url.includes("undefined")===false&&url.length>0) {
          this.state.fileList[0] = { url: url}
        }
        this.setState({
          ...data.commodity,
        })
      }
    }
  }

  getQiniuToken = () => {
    fetchQiNiuToken().then((data) => {
      this.setState({ QiniuToken: data.token })
    })
  }

  getCommodityDetailData = async () => {
    const { id } = this.props.chosenItem
    const club_id = sessionStorage.getItem('club_id')
    const { data, detail, status } = await getCommodityDetail(id, club_id)
    const imgList = []
    if (data.commodity.photoUrl) {
      imgList.push({ url: fixPhotoUrl(data.commodity.photoUrl) })
    }
    this.setState({
      // detailData: data.commodity,
      ...data.commodity,
      allData: data,
      fileList: imgList,
    })
    this.props.getAllData()
  }

  handleUpload = async (info) => {
    console.log(info)
    // this.setState({ fileList: info.fileList })
    // if (info.file.status == 'done') {
    //   let imgList = [].concat(this.state.fileList)
    //   imgList[0].url = fixPhotoUrl(info.file.response.url)
    //   this.setState(
    //     {
    //       fileList: imgList,
    //       // photoUrl: info.file.response.url,
    //     },
    //     () => {
    //       console.log(this.state.fileList)
    //     }
    //   )
    // }

    let token = this.state.QiniuToken
    let file = info.file
    let form = new FormData()
    form.append('token', token)
    form.append('file', file)
    if (token != ''&&Array.isArray(info.fileList) && info.fileList.length > 0) {
      const { data, status, detail } = await fetchQiniu(form)
      info.fileList[0].url = fixPhotoUrl(data.url)
      info.fileList[0].status = 'done'
      this.setState(
          {
            fileList: info.fileList,
          },
          () => {
            console.log(this.state.fileList)
          }
      )
    } else {
      Message.error('上传失败')
    }
  }

  switchOnchange = (checked) => {
    this.setState({ isNonStandard: checked })
    this.props.setIsNonStandard(checked)
  }

  postNewCommodity = async () => {
    const { categoryId, name, unit, order, fileList, barCode, isNonStandard } =
        this.state
    if (categoryId && name && unit ) {
      this.props.setConfirmLoading(true)
      let params = {
        categoryId: categoryId,
        name: name,
        unit: unit,
        order: 0,
        photoUrl: fileList[0] ? fixPhotoUrl(fileList[0].url) : '',
        barCode: barCode,
        isNonStandard: isNonStandard,
      }
      if (this.props.modalState == 'isDetails') {
        params.id = this.props.chosenItem.id
        params.photoUrl = fileList[0] ? fixPhotoUrl(fileList[0].url) : ''
      }
      const { data, status, detail } = await addOrEditCommodity(params)
      if (status == 1) {
        if (this.props.modalState == 'isAddCommodity') {
          Message.success('保存成功')
          this.setState({ newListingId: data }, () => {
            this.props.setActiveTab('2')
            // this.props.getIdFromInfo()
            // this.props.setConfirmLoading(false)
          })
        }
        if (this.props.modalState == 'isDetails') {
          Message.success('保存成功')
          this.props.setConfirmLoading(false)
          this.props.setIsVisible(false)
          this.props.getList()
        }
      } else {
        Message.error(detail)
        this.props.setConfirmLoading(false)
      }
    } else {
      Message.error('请完整填写信息')
    }
  }

  removeImg = () => {
    this.setState({ fileList: [] })
  }

  render() {
    const {
      fileList,
      barCode,
      photoUrl,
      name,
      unit,
      order,
      categoryId,
      isNonStandard,
    } = this.state

    return (
        <Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
          <Form.Item
              label={
                <span>
              {/* <span className="color_red">* </span> */}
                  <span>条形码</span>
            </span>
              }
          >
            <Input
                onPressEnter={this.getBarCode}
                onBlur={this.getBarCode}
                value={barCode}
                onChange={(e) => this.setState({ barCode: e.target.value })}
            />
          </Form.Item>

          <Form.Item
              label={
                <span>
              <span>商品图片</span>
            </span>
              }
              valuePropName="fileList"
          >
            {/* {photoUrl ? (
            <img
              src={photoUrl}
              alt="avatar"
              style={{
                width: '100px',
              }}
            />
          ) : ( */}
            <Upload
                // action="//up-z0.qbox.me/"
                listType="picture-card"
                onChange={this.handleUpload}
                fileList={fileList}
                // headers="{'Content-Type': 'multipart/form-data'}"
                // data={{ token: this.state.QiniuToken }}
                accept=".jpg,.jpeg,.png"
                onRemove={this.removeImg}
                beforeUpload={(file) =>
                  validateImageFile(file) ? false : Upload.LIST_IGNORE
                }
            >
              {fileList.length < 1 ? (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
              ) : null}
            </Upload>
            {/* )} */}
          </Form.Item>
          <Form.Item
              label={
                <span>
              <span className="color_red">* </span>
              <span>商品名称</span>
            </span>
              }
          >
            <Input
                value={name}
                onChange={(e) => this.setState({ name: e.target.value })}
            />
          </Form.Item>
          <Form.Item
              label={
                <span>
              <span className="color_red">* </span>
              <span>单位</span>
            </span>
              }
          >
            <Input
                value={unit}
                onChange={(e) => this.setState({ unit: e.target.value })}
            />
          </Form.Item>
          {/* <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>商品排序</span>
            </span>
          }
        >
          <Input
            placeholder="数值越小商品排列越前面（范围：1~255）"
            value={order}
            onChange={(e) => this.setState({ order: e.target.value })}
          />
        </Form.Item> */}
          <Form.Item
              label={
                <span>
              <span className="color_red">* </span>
              <span>所属分类</span>
            </span>
              }
          >
            <Select
                defaultValue=""
                value={categoryId}
                onChange={(value) => {
                  this.setState({ categoryId: value })
                }}
            >
              <Select.Option value="">选择分类</Select.Option>
              {this.props.categoryList &&
                  this.props.categoryList.map((item, idx) => {
                    return (
                        <Select.Option value={item.id} key={item.id}>
                          {item.name}
                        </Select.Option>
                    )
                  })}
            </Select>
          </Form.Item>
          <Form.Item label="是否加工制品">
            <Switch
                onChange={this.switchOnchange}
                checked={this.state.isNonStandard}
            />
          </Form.Item>
        </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/info.js